// ---------- Validators ----------

const isStrongPassword = (value) => {
  if (!value) return false;
  if (value.length < 12) return false;
  // Reject all-numeric passwords (matches Django's NumericPasswordValidator)
  if (/^\d+$/.test(value)) return false;
  return true;
};

const isValidDob = (value) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!m) return false;
  const mm = +m[1];
  const dd = +m[2];
  const yy = +m[3];

  // Validate month
  if (mm < 1 || mm > 12) return false;

  // Validate day
  const dim = new Date(yy, mm, 0).getDate();
  if (dd < 1 || dd > dim) return false;

  // Validate age - must be 18 or older
  const dob = new Date(yy, mm - 1, dd); // mm-1 because JS months are 0-indexed
  const today = new Date();

  // Calculate age
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  const dayDiff = today.getDate() - dob.getDate();

  // Adjust age if birthday hasn't occurred this year yet
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  // Must be at least 18 years old
  return age >= 18;
};

const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

const isValidPhoneNumber = (value) => {
  const digits = (value || '').replace(/[^\d]/g, '');
  return digits.length >= 6 && digits.length <= 15;
};

const isValidUsername = (value) => /^[A-Za-z0-9._-]{3,20}$/.test(value);

const isValidUrl = (value) => {
  try {
    const url = new URL(value);
    return url.isValidUrl();
  } catch (err) {
    return false;
  }
};

const isValidZip = (value) => {
  const zipPattern = /^[0-9]{4,10}$/;
  return zipPattern.test(value);
};

export {
  isStrongPassword,
  isValidDob,
  isValidEmail,
  isValidPhoneNumber,
  isValidUrl,
  isValidUsername,
  isValidZip,
};
